import { render, staticRenderFns } from "./friend_unconfirmed.vue?vue&type=template&id=5afaa2b7"
import script from "./friend_unconfirmed.vue?vue&type=script&lang=js"
export * from "./friend_unconfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports